import ListFrame from '../components/List/ListFrame';

const ListPage = () => {
  return <ListFrame />;
};

export default ListPage;
